import { metadataItemsConstants } from '../_constants';

const initialState = {
    items: [],
    loading: false,
    error: null
};

export function metadataItems(state = initialState, action) {
    switch (action.type) {
        case metadataItemsConstants.FETCH_ALL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case metadataItemsConstants.FETCH_ALL_SUCCESS:
            return {
                ...state,
                loading: false,
                items: action.metadataItems,
                error: null
            };
        case metadataItemsConstants.FETCH_ALL_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        default:
            return state;
    }
}
